import brand from 'brand'
import SummaryExternalPayment from 'pages/summary-external-payment'
import SummaryNoPayment from 'pages/summary-no-payment'

export default function Page() {

  if (brand.features.externalPaymentEnabled) {
    return <SummaryExternalPayment></SummaryExternalPayment>
  }

  return <SummaryNoPayment></SummaryNoPayment>
}
